import { createAction } from "redux-actions";

export const SET_SALES_TRANSACTIONS_FIRESTORE_LOADING =
  "USER_DATA_LOAD/SET_SALES_TRANSACTIONS_FIRESTORE_LOADING";
export const SET_SALES_TRANSACTIONS_INITIAL_SYNC_COMPLETE =
  "USER_DATA_LOAD/SET_SALES_TRANSACTIONS_INITIAL_SYNC_COMPLETE";
export const SET_UNREVIEWED_PRESENCE = "USER_DATA_LOAD/SET_UNREVIEWED_PRESENCE";

/** Single flag while Firestore sales/tx (and related) listeners are awaiting initial snapshots. */
export const setSalesTransactionsFirestoreLoading = createAction<boolean>(
  SET_SALES_TRANSACTIONS_FIRESTORE_LOADING
);

export const setSalesTransactionsInitialSyncComplete = createAction<boolean>(
  SET_SALES_TRANSACTIONS_INITIAL_SYNC_COMPLETE
);

export interface UnreviewedPresence {
  sales: boolean;
  returns: boolean;
  transactions: boolean;
}

/**
 * Lightweight “is there anything to review?” flags for the deferred-unreviewed-load
 * feature. They let notifications keep working without loading every unreviewed doc.
 */
export const setUnreviewedPresence = createAction<Partial<UnreviewedPresence>>(
  SET_UNREVIEWED_PRESENCE
);
